import { ProjectCommercialsForm } from "@redux/reducers/commercialReducer";

export enum ActionType {
  COMMERCIAL_DETAIL_BY_PID = "COMMERCIAL_DETAIL_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}
export interface ICommercialByPid {
  type: ActionType.COMMERCIAL_DETAIL_BY_PID;
  payload: ProjectCommercialsForm[];
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = ICommercialByPid | IResetReduxState;
